define(['text!./templates/quote-offering.html'],
    (templateStr) => {
        return [()=> {
            return {
                restrict: 'A',
                template: templateStr,
                scope: {
                    quote: '=gwQnbQuoteOffering',
                    buy: '&'
                }
            };
        }];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/integration/quoteandbind/directives/QuoteOffering.js